<template>
  <div class="grid-item" :title="name">
    <div class="grid-item-thumb">
      <img v-if="isImage" :src="loaded ? url : placeholderSrc" :alt="name" />
      <font-awesome-icon v-else-if="type === 'folder'" icon="folder" class="grid-item-icon" />
      <font-awesome-icon v-else-if="isPdf" icon="file-pdf" class="grid-item-icon" />
      <font-awesome-icon v-else icon="file-alt" class="grid-item-icon" />
    </div>
    <div class="grid-item-name">{{ name }}</div>
    <div class="grid-item-delete" v-if="type === 'file' && canDelete" @click.stop="$emit('delete')">
      <font-awesome-icon icon="trash" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FolderGridItem",
  props: {
    type: String,
    name: String,
    id: String,
    url: String,
    mimeType: String,
    canDelete: Boolean,
    loaded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      placeholderSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
    };
  },
  computed: {
    isImage() {
      return this.mimeType?.startsWith("image/");
    },
    isPdf() {
      return this.mimeType === "application/pdf";
    }
  }
};
</script>

<style lang="scss">
.grid-item {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: 8px;
  border-radius: 6px;

  &:hover {
    background-color: #f6f5f6;

    .grid-item-delete {
      opacity: 1;
    }
  }

  .grid-item-thumb {
    width: 200px;
    height: 200px;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    border-radius: 6px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .grid-item-icon {
      font-size: 2.5rem;
      color: #f2671c;
    }
  }

  .grid-item-name {
    margin-top: 6px;
    width: 100%;
    font-size: 0.85rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .grid-item-delete {
    position: absolute;
    top: 4px;
    right: 4px;
    opacity: 0;
    transition: opacity 0.15s ease;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 50%;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: red;

    &:hover {
      color: #ef4f4f;
    }
  }
}
</style>
